import React from "react";
import { TopToolbar } from "react-admin";
import { Box } from "@mui/material";
import { MobileFilterButton } from "./MobileFilterButton";
import { MobileListSort } from "./MobileListSort";
import type { MobileListSortOption } from "./MobileListSort";

type Props = {
  filters: React.ReactNode[];
  sortOptions: readonly MobileListSortOption[];
};

export const MobileListActions = ({ filters, sortOptions }: Props) => (
  <TopToolbar>
    <Box sx={{ alignItems: "center", display: "flex", gap: 0.5, mt: 2 }}>
      <MobileFilterButton filters={filters} />
      <MobileListSort options={sortOptions} />
    </Box>
  </TopToolbar>
);
